// Service Worker の登録ヘルパー（cra-template-pwa の標準実装がベース）。
//
// 本番ビルドでのみ登録される。開発サーバーでは Service Worker は生成されないため、
// register() を呼んでも何もしない。
//
// 注意: 登録された Service Worker はページの読み込みより後に動き出す。
// そのため、更新は「次回の起動から」ではなく「ユーザーが更新を了承したとき」に
// 適用する（onUpdate → 更新通知UI → SKIP_WAITING）。

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // IPv6 のループバック
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 のループバック
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  if (!('serviceWorker' in navigator)) {
    return;
  }

  // PUBLIC_URL が別オリジンの場合（CDN 配信等）は Service Worker が動かない。
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      // localhost では、Service Worker が本当に存在するかを先に確かめる。
      checkValidServiceWorker(swUrl, config);

      navigator.serviceWorker.ready.then(() => {
        console.log('このアプリはキャッシュ優先で動作しています（Service Worker 有効）。');
      });
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state !== 'installed') {
            return;
          }
          if (navigator.serviceWorker.controller) {
            // 古いコンテンツが残っている状態。新しい内容は待機中の
            // Service Worker が制御を取ってから反映される。
            console.log('新しいバージョンを取得しました。適用の了承待ちです。');

            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            // 初回インストール。この時点でオフライン利用が可能になる。
            console.log('オフラインでの起動に必要な内容をキャッシュしました。');

            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Service Worker の登録に失敗しました:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Service Worker が見つからない場合はページをリロードして登録を解除する。
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then(response => {
      const contentType = response.headers.get('content-type');
      const isJavaScript = contentType != null && contentType.indexOf('javascript') !== -1;

      if (response.status === 404 || !isJavaScript) {
        // Service Worker が存在しない。登録を解除してリロードする。
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('通信できないため、オフラインモードで起動しています。');
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker.ready
    .then(registration => {
      registration.unregister();
    })
    .catch(error => {
      console.error(error.message);
    });
}
